"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

require("./Hue.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Hue = function Hue(_ref) {
  var onChange = _ref.onChange,
      _ref$hsl = _ref.hsl,
      hsl = _ref$hsl === void 0 ? {} : _ref$hsl;
  (0, _react.useEffect)(function () {
    return function () {
      return unbindEventListeners();
    };
  }, []);
  var container = (0, _react.useRef)(null);

  var handleChange = function handleChange(e) {
    var change = (0, _utils.calculateHueChange)(e, 'vertical', hsl, container.current);
    change && typeof onChange === 'function' && onChange(change, e);
  };

  var handleMouseDown = function handleMouseDown(e) {
    handleChange(e);
    window.addEventListener('mousemove', handleChange);
    window.addEventListener('mouseup', handleMouseUp);
  };

  var handleMouseUp = function handleMouseUp() {
    unbindEventListeners();
  };

  function unbindEventListeners() {
    window.removeEventListener('mousemove', handleChange);
    window.removeEventListener('mouseup', handleMouseUp);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cp-hue"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cph-container",
    ref: container,
    onMouseDown: handleMouseDown,
    onTouchMove: handleChange,
    onTouchStart: handleChange
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cph-pointer",
    style: {
      top: "".concat(-(hsl.h * 100 / 360) + 100, "%")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cph-slider",
    style: {
      backgroundColor: "hsl(".concat(hsl.h, ", 100%, 50%)")
    }
  }))));
};

var _default = Hue;
exports["default"] = _default;